import { apiHandler } from "../buyerApiHandler";

export type CollectionType = "store" | "item";
export type CollectionPage = "home" | "banner";

export type CollectionPayload = {
  title: string;
  description?: string;
  image_url?: string;
  type: CollectionType;
  page: CollectionPage;
  status?: boolean;
};

export const getCollections = (params?: {
  page?: number;
  limit?: number;
  status?: boolean;
}) => {
  return apiHandler("get", "/collection", undefined, { params });
};

export const getCollectionById = (id: number) => {
  return apiHandler("get", `/collection/${id}`);
};

export const createCollection = (payload: CollectionPayload | FormData) => {
  const isFormData = typeof FormData !== "undefined" && payload instanceof FormData;
  return apiHandler("post", "/collection", payload, {
    headers: isFormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" },
  });
};

export const updateCollection = (id: number, payload: Partial<CollectionPayload> | FormData) => {
  const isFormData = typeof FormData !== "undefined" && payload instanceof FormData;
  return apiHandler("patch", `/collection/${id}`, payload, {
    headers: isFormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" },
  });
};

export const deleteCollection = (id: number) => {
  return apiHandler("delete", `/collection/${id}`);
};

export const moveCollection = (id: number, newPosition: number) => {
  return apiHandler("patch", `/collection/${id}/move`, { new_position: newPosition }, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getCollectionEntries = (collectionId: number) => {
  return apiHandler("get", `/collection/${collectionId}/entries`);
};

export const getCollectionSelectableStores = (params?: {
  page?: number;
  limit?: number;
  search?: string;
}) => {
  return apiHandler("get", "/collection/options/stores", undefined, { params });
};

export const getCollectionSelectableItems = (params?: {
  page?: number;
  limit?: number;
  search?: string;
  store_id?: number;
}) => {
  return apiHandler("get", "/collection/options/items", undefined, { params });
};

export const getCollectionResolvedEntities = (
  collectionId: number,
  params?: { page?: number; limit?: number },
) => {
  return apiHandler("get", `/collection/${collectionId}/items`, undefined, { params });
};

export const addCollectionEntries = (collectionId: number, entityIds: number[]) => {
  return apiHandler(
    "post",
    `/collection/${collectionId}/entries`,
    { entity_ids: entityIds },
    { headers: { "Content-Type": "application/json" } },
  );
};

export const removeCollectionEntry = (collectionId: number, entryId: number) => {
  return apiHandler("delete", `/collection/${collectionId}/entries/${entryId}`);
};

export const reorderCollectionEntries = (
  collectionId: number,
  entries: Array<{ entry_id: number; new_position: number }>,
) => {
  return apiHandler(
    "patch",
    `/collection/${collectionId}/entries/reorder`,
    { entries },
    { headers: { "Content-Type": "application/json" } },
  );
};
